export default {
    data() {
        return {

        };
    },

    methods: {
        getQueryParam(querykey, fallback) {
            var key = (this.pk ?? '') + querykey;
            var value = this.$route.query[key];
            if (value) {
                 value = JSON.parse(value); 
                return value;
            }
            else { return fallback; }
        },
        setQueryParam(querykey, update) {
            var key = this.pk ?? '';
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    [key + querykey]: this.validateUpdate(update)
                        ? JSON.stringify(update)
                        : undefined,
                },
            });
        },

        validateUpdate(update) {
            return update &&
                (!Array.isArray(update) ||
                    (Array.isArray(update) && update.some(x => x !== undefined && x !== null)));
        },
    },

    computed: {
        isFiltered() {
            var key = this.pk ?? '';
            var filterkeybase = key + 'filter-';
            return Object.keys(this.$route.query).some(x => x.includes(filterkeybase) && this.$route.query[x]);
        },
        isFilteredSearchExcluded() {
            var key = this.pk ?? '';
            var filterkeybase = key + 'filter-';
            var searchkey = key + 'filter-keyword';
            return Object.keys(this.$route.query).some(x => x.includes(filterkeybase) && x != searchkey && this.$route.query[x]);
        },

        isSorted() {
            return this.sorting && this.sorting.some((x) => x.key != "" && x.key != null);
        },

        sorting() {
            var key = this.pk ?? '';
            return this.getQueryParam(key + "sorting", []);
        },

    },
}